<script lang="ts">
  export let horizontalAlignment: "center" | "left" | "right" = "center";

  import InlineTooltip from "@shared/svelte/Components/InlineTooltip.svelte";

  const tooltipText =
    "These discounts are not guaranteed. They will apply at the discretion of your sales rep on your final invoice and will not apply to your cart total.";

</script>

<p class="fizz-text-strong fizz-stack-8">
  <span class="fizz-inline-4" style="vertical-align: text-top"
    ><InlineTooltip text={tooltipText} size={12} {horizontalAlignment} /></span
  > Special Discounts
</p>
